import { Box, Icon, IconButton } from "@mui/material";
import useRequest from "api/useRequest";
import { modalHide, modalShow } from "app/App/actions";
import { sellerFetchAll } from "app/Payment/Seller/actions";
import { SellerModel } from "app/Payment/Seller/interfaces";
import { AxiosResponse } from "axios";
import { FC, useState } from "react";
import { useDispatch } from "react-redux";
import { Loader, PaperHeader, Table } from "ui";
import { IFormContext } from "ui/Form/FormContext";

type TGastroPaySellers = {
    context: IFormContext;
    errors: string[];
    sellersId: string;
};

const GastroPaySellers: FC<TGastroPaySellers> = ({
    context,
    errors,
    sellersId,
}) => {
    const dispatch = useDispatch();
    const [sellersById, setSellersById] = useState<Record<number, SellerModel>>(
        {}
    );
    const { isPending } = useRequest(
        sellerFetchAll((response: AxiosResponse) => {
            const temp = {} as Record<number, SellerModel>;
            response.data.data.forEach((item: SellerModel) => {
                temp[item.id] = item;
            });
            setSellersById(temp);
        })
    );

    const handleAddSeller = () => {
        dispatch(
            modalShow("SellerSelectModal", {
                onClick: (event: any, seller: SellerModel) => {
                    const value = new Set([
                        ...context.data[sellersId],
                        seller.id,
                    ]);

                    context.onChange({
                        id: sellersId,
                        value: Array.from(value),
                    });

                    dispatch(modalHide("SellerSelectModal"));
                },
            })
        );
        //
    };

    if (isPending || Object.keys(sellersById).length === 0) {
        return <Loader />;
    }

    return (
        <Box sx={{ mt: 2 }}>
            <PaperHeader
                actions={
                    <IconButton onClick={handleAddSeller}>
                        <Icon>add</Icon>
                    </IconButton>
                }
                sx={{ mt: 2 }}
                title="Sellers"
            />
            {errors && errors.length > 0 && (
                <Box sx={{ mb: 2 }}>
                    {errors.map((error, index) => (
                        <Box key={index} color="error.main">
                            {error}
                        </Box>
                    ))}
                </Box>
            )}
            <Table
                id="gastro-pay-sellers-table"
                columns={[
                    {
                        field: "id",
                        headName: "ID",
                        renderCell: (item: number) => ({
                            children: sellersById[item].seller_id,
                        }),
                    },
                    {
                        field: "name",
                        headName: "Name",
                        renderCell: (item: number) => ({
                            children: sellersById[item].name,
                        }),
                    },
                    {
                        field: "actions",
                        renderCell: (item: number) => ({
                            children: (
                                <IconButton
                                    onClick={() => {
                                        context.onChange({
                                            id: sellersId,
                                            value: context.data[
                                                sellersId
                                            ].filter(
                                                (id: number) => id !== item
                                            ),
                                        });
                                    }}
                                >
                                    <Icon>delete</Icon>
                                </IconButton>
                            ),
                        }),
                    },
                ]}
                rows={context.data[sellersId] || []}
            />
        </Box>
    );
};

export default GastroPaySellers;
